<template>
    <v-text-field
        v-bind="$attrs"
        v-on="$listeners"
        :id="inputId"
        :aria-required="required"
        :aria-invalid="hasError"
        :aria-describedby="describedBy"
        :error="hasError"
        :error-messages="errorMessages"
    >
        <!-- Repassa slots do componente pai -->
        <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
        </template>
        
        <!-- Mensagem de erro para leitores de tela -->
        <template v-if="hasError" v-slot:message="{ message }">
            <span :id="errorId" role="alert">{{ message }}</span>
        </template>
    </v-text-field>
</template>

<script>
export default {
    name: 'EmcFormAccessibleInput',
    
    inheritAttrs: false,
    
    props: {
        /**
         * Campo obrigatório
         */
        required: {
            type: Boolean,
            default: false
        },
        
        /**
         * Mensagens de erro
         */
        errorMessages: {
            type: [Array, String],
            default: () => []
        },
        
        /**
         * ID de elemento que descreve o campo (hint, instrução, etc.)
         */
        hintId: {
            type: String,
            default: null
        }
    },
    
    data() {
        return {
            inputId: `input-${Math.random().toString(36).substr(2, 9)}`,
            errorId: `error-${Math.random().toString(36).substr(2, 9)}`
        }
    },
    
    computed: {
        hasError() {
            if (Array.isArray(this.errorMessages)) {
                return this.errorMessages.length > 0
            }
            return !!this.errorMessages
        },
        
        describedBy() {
            const ids = []
            
            if (this.hintId) {
                ids.push(this.hintId)
            }
            
            if (this.hasError) {
                ids.push(this.errorId)
            }
            
            return ids.length > 0 ? ids.join(' ') : undefined
        }
    }
}
</script>
